//import Cookies from 'universal-cookie';
import { UserTypeEnum } from '../enums/UserTypeEnum';

export class AuthService {

    constructor() { //public cookies: Cookies){
        this.onAuthChangeEvents = [];
    }

    private onAuthChangeEvents: (() => any)[];

    public addOnAuthChangeEvent(event:any) {
        this.onAuthChangeEvents.push(event);
    }

    private onAuthChange() {
        this.onAuthChangeEvents.forEach((val) => {
            val();
        });
    }

    public getToken() {
        //var token = this.cookies.get('token');
        //if (!token)
        var token = localStorage.getItem('token');
        return token;
    }

    public setToken(token: string, maxAge:number) {    
        //this.cookies.set('token', token, { path: '/', maxAge: maxAge });
        localStorage.setItem('token', token);
        this.onAuthChange();
    }

    public isAuthenticated() {
        return !!this.getToken();
    }

    public hasAnyRoles(roles: string[]) {
        if (!roles || !roles.length)
            return true;
        var payload = this.getTokenPayload();
        return payload.roles.split(',').some(v => {
            return roles.some(r => {
                return r == v;
            });
        });
    }

    public getUserType(): UserTypeEnum {
        var payload = this.getTokenPayload();
        var retval = UserTypeEnum.Contractor;
        UserTypeEnum.getValueList().forEach(t => { if (t.label == payload.userType) retval = t.id });
        return retval;
    }

    public logout() {
        //this.cookies.remove('token');
        localStorage.removeItem('token');
        this.onAuthChange();
    }

    private getTokenPayload() {
        var token:string = this.getToken();

        var payload = token.split('.')[1];

        var decoded = atob(payload);

        return JSON.parse(decoded);
    }
}


// WEBPACK FOOTER //
// ./services/auth.service.ts